import { Injectable } from "@angular/core";
import { MatomoConfiguration } from "ngx-matomo-client";

// TODO 14420 - Matomo - implement new Matomo tracking package
//import { MatomoConfiguration } from "@ngx-matomo/tracker";

@Injectable({
    providedIn: "root"
})
export class MatomoConfigService {
    // "dummy" data, otherwise tracker throws due to null properties
    // public myBackendConfig: any = { trackerUrl: "//eforsyning.dk:42555/matomo", siteId: "0" };
    // public myBackendConfig: any = { trackerUrl: "//eforsyning.matomo.cloud/", siteId: "0" };
    //public myBackendConfig: any = { trackerUrl: "//matomo.eforsyning.dk", siteId: "0" };

    // TODO 14420 - Matomo - implement new Matomo tracking package

    public myBackendConfig: {
        siteId: 0;
        trackerUrl: "//matomo.eforsyning.dk";
        scriptUrl: `//matomo.eforsyning.dk/js/container_<containerId>.js`;
        requireConsent: "tracking";
    };

    public buildConfig(matomoSiteId: number): MatomoConfiguration {
        //console.log("buildConfig", matomoSiteId);
        return {
            siteId: matomoSiteId?.toString(),
            trackerUrl: this.myBackendConfig.trackerUrl ?? "//matomo.eforsyning.dk"
        };
    }
}
